import React, { useMemo } from "react";
import { encodeProject } from "../../utils/serialization";
import { mapApiInteractions } from "../../utils/interactionMapper";
import './style.css'

export default function VideoPreviewModal({ open, onClose, video }) {
  const embedUrl = useMemo(() => {
    if (!video) return null;

    const project = {
      title: video.AchievementVideoTitle,
      videoUrl: video.VideoUrl,
      interactions: mapApiInteractions(video.VideoInteractionDetails || [])
    };

    const encoded = encodeProject(project);

    return `${window.location.origin}/embed?data=${encoded}`;
  }, [video]);

  if (!open || !embedUrl) return null;

  return (
    <div className="video-modal-backdrop" onClick={onClose}>
      <div
        className="video-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="video-modal-close"
          onClick={onClose}
        >
          ✕
        </button>

        <iframe
          title="Video Önizleme"
          src={embedUrl}
          allow="autoplay; fullscreen"
        />
      </div>
    </div>
  );
}